import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { error } from 'highcharts';
import { Subscription } from 'rxjs';
import { OverViewLng, OverViewScrubber, OverViewStatus } from 'src/app/interface/overview.interface';
import { DistributionDataService } from 'src/app/services/distributionData.service';
import { ToasterService } from 'src/app/services/toaster.service';
import { VesselsService } from 'src/app/services/vessels.service';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit {
  @Input() shipDetailsbasicinfo : any;
  @Output() isScrubberVisible = new EventEmitter();
  updateEditStatusDetails: any;
  toolTipConfig: {
    width: "auto"
  }
  mutableShipDetails: any;
  updateLngDetails: any;
  getLngData: any;
  getScrubberData: any;
  updateScrubberDetails: any = {};
  editStatusDetails: any;
  // isLoader:boolean = true;
  overViewStatusInterface:OverViewStatus = {
    isLoader: true
  };
  overViewScrubberInterface:OverViewScrubber= {
    isLoader: true
  };
  overViewLngInterface:OverViewLng= {
    isLoader: true
  };

  constructor(private vesselService:VesselsService,
    private router:Router,
    private distributionService:DistributionDataService,
    private toasterService: ToasterService,
    private cdr:ChangeDetectorRef,
    private datePipe: DatePipe) {    
  }

  ngOnInit() {
    this.updateEditStatusDetails = {};
    // this.mutableShipDetails  = { ...this.shipDetailsbasicinfo };
    // console.log(this.mutableShipDetails)
    this.getEditStatusDetails();
    this.getLngDataUsage();
    this.getScrubberDataUsage();
    
  }
  // ------edit status-------
  getEditStatusDetails(){
    let input = {"vslNumber": this.shipDetailsbasicinfo?.vslNumber};
    this.vesselService.getEditStatusDetails(input).subscribe({
      next:(res:any)=>{
        if(res?.data?.getVesselStatusForEdit?.success){
          this.editStatusDetails = res?.data?.getVesselStatusForEdit?.data;
          this.overViewStatusInterface.isLoader = false;
        }
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error);
      }
    })
  }
  editStatusLoader(){
    this.overViewStatusInterface.isLoader = true;
  }
  errorEditStatusLoader(){
    this.overViewStatusInterface.isLoader = false;
  }
  updateEditStatus(e:any){
    this.editStatusDetails = {};
    this.updateEditStatusDetails = e;
    console.log(this.updateEditStatusDetails)
    console.log(this.mutableShipDetails)
    console.log(this.shipDetailsbasicinfo)
    this.shipDetailsbasicinfo = {...this.shipDetailsbasicinfo,
    statusInfo:this.updateEditStatusDetails,
    statusEffectiveFrom:this.updateEditStatusDetails?.upcomingChange?.effectiveDate};
    this.editStatusDetails = this.updateEditStatusDetails;
    console.log("dddd",this.shipDetailsbasicinfo)
    this.overViewStatusInterface.isLoader = false;
  }
  // -----lng usage----
  getLngDataUsage(){
    let input = {"vslNumber": this.shipDetailsbasicinfo?.vslNumber};
    this.vesselService.getLngDetails(input).subscribe({
      next:(res:any)=>{
        if(res?.data?.getLngDetails?.success){
          this.getLngData = res?.data?.getLngDetails?.data;
          this.overViewLngInterface.isLoader = false;
          console.log( this.getLngData)
          this.updateLngDetails = {};
        }else{
          this.toasterService.openToast('Error', error);
        }
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error);
      }
    })
  }
  lngStatusLoader(){
    this.overViewLngInterface.isLoader = true;
  }
  errorLngStatusLoader(){
    this.overViewLngInterface.isLoader = false;
  }
  updateLngData(e:any){
    this.getLngData = {};
    this.updateLngDetails = e;
    console.log("dddd",this.updateLngDetails)
    this.getLngData = this.updateLngDetails?.lngDetails;
    this.overViewLngInterface.isLoader = false;

  }


  // -----scrubber usage----

  getScrubberDataUsage(){
    let input = {"vslNumber": this.shipDetailsbasicinfo?.vslNumber};
    this.vesselService.getScrubberUsageDetails(input).subscribe({
      next:(res:any)=>{
        if(res?.data?.getScrubberUsageDetails?.success){
          this.getScrubberData = res?.data?.getScrubberUsageDetails?.data;
          console.log( this.getScrubberData)
          this.overViewScrubberInterface.isLoader = false;
          this.updateScrubberDetails = {};
          this.isScrubberVisible.emit(this.getScrubberData);
        }else{
          this.toasterService.openToast('Error', error);
        }
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error);
      }
    })
  }
  scrubberUsageLoader(){
    this.overViewScrubberInterface.isLoader = true;
  }
  errorScrubberUsageLoader(){
    this.overViewScrubberInterface.isLoader = false;
  }
  updateScrubberData(e:any){
    this.getScrubberData = {};
    this.updateScrubberDetails = e;
    console.log("dddd",this.updateScrubberDetails)
    this.getScrubberData = this.updateScrubberDetails;
    this.overViewScrubberInterface.isLoader = false;
    if(e){
      console.log(this.getScrubberData)
      this.isScrubberVisible.emit(this.getScrubberData);
    }
   
  }
}